import React, { useState, useEffect, useRef} from 'react';
import {
  Box, Typography, Button, List, ListItem, ListItemButton,
  ListItemText, TextField, Paper, Autocomplete, Grid, Checkbox
} from '@mui/material';
import Swal from 'sweetalert2';
import GestionPreguntaEncuesta from './GestionPreguntaEncuesta';
import { useUser } from '../contexts/UserContext';
import imageCompression from 'browser-image-compression';
import { event } from 'jquery';
import axios from 'axios';
import { useAccesos } from '../contexts/AccesosContext';


function AddEncuesta ({ handleNewEncuesta, editEncuesta, cancelarEdicion }){
   const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const encuesta = process.env.REACT_APP_ROUTE;

  const [seccionSeleccionada, setSeccionSeleccionada] = useState('Encuesta');

  // Form states por separado si quieres manejar inputs
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [fechaEnvio, setfechaEnvio] = useState('');
  const [fechaRespuesta, setfechaRespuesta] = useState('');
  const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
  const [modificacion, setModificacion] = useState('');
  const [estados, setEstados] = useState([]);
  const [areas, setAreas] = useState([]);
  const [areaSeleccionada, setAreaSeleccionada] = useState(null);
  const [IngresadoPor, setIngresadoPor] = useState('');
  const [preguntas, setPreguntas] = useState(['']);
  const [activa, setActiva] = useState(false);
  // const [urlImagen, setUrlImagen] = useState(null);
  const [urlImagenInicio, setUrlImagenInicio] = useState('');
  const [imagenInicioPreview, setImagenInicioPreview] = useState(null);
  const [eliminarInicio, setEliminarInicio] = useState(false);
  const [existingInicioUrl, setExistingInicioUrl] = useState(null);

  const [urlImagenFinal, setUrlImagenFinal] = useState('');
  const [imagenFinalPreview, setImagenFinalPreview] = useState(null);
  const [eliminarFinal, setEliminarFinal] = useState(false);
  const [existingFinalUrl, setExistingFinalUrl] = useState(null);

  const inputInicioRef = useRef(null);
  const inputFinalRef = useRef(null);
  const [linkGenerado, setLinkGenerado] = useState('');

 

  const { user } = useUser();
  const { tienePermiso } = useAccesos();
    // Obtener la fecha y hora actual
    function obtenerFechaISOsinZ() {
      const fecha = new Date();
      let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
      fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
      return fechaISO;
  }

    const fetchPreguntasPorEncuesta = async (idEncuesta) => {
      try {
        const response = await fetch(`${server}/CrmPreguntaEncuestums/poridEncuesta/${idEncuesta}`);
        const data = await response.json();
        setPreguntas(data.$values || []);
      } catch (error) {
        console.error("Error al obtener las preguntas:", error);
      }
    };

   const fetchAreas = async () => {
                try {
                    const response = await fetch(`${server}/CrmAreaEncuestums`); 
                    const data = await response.json();
                    setAreas(data.$values);
                } catch (error) {
                    console.error('Error al cargar las áreas de las encuestas:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar las áreas de las encuestas: ' + error,
                    });
                }
            };

        useEffect(() => {
          fetchAreas();
        }, []);
 // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();
    // Carga inicial de datos si estamos en modo edición
      useEffect(() => {
        if (editEncuesta) {
          setTitulo(editEncuesta.titulo);
          setDescripcion(editEncuesta.descripcion); // Cargar la descripción de la raza para editar
    
          const areaMatch = areas.find(e => e.id === editEncuesta.idAreaEncuesta);


          setAreaSeleccionada(areaMatch || null);
          setActiva(editEncuesta.activa || false);
          setModificacion(2);
          setIngresadoPor(editEncuesta.ingresadoPor);
          setUrlImagenInicio(editEncuesta.urlImagenInicioEncuesta || null);
          setUrlImagenFinal(editEncuesta.urlImagenFinalEncuesta || null);
          

        console.log("URL imagen inicio:", editEncuesta.urlImagenInicioEncuesta);   // 🔍 Imprime la URL de la imagen inicio
        console.log("URL imagen final:", editEncuesta.urlImagenFinalEncuesta); 
      
        } else {
          setTitulo('');
          setDescripcion(''); // Resetear la descripción si no estamos editando
          setActiva(false);
          setAreaSeleccionada(null);
          setModificacion(1);
          setIngresadoPor('');
          setExistingInicioUrl(null);
        setExistingFinalUrl(null);
      
        }
    }, [editEncuesta]);


    const comprimirImagen = async (imagen) => {
      const opciones = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        initialQuality: 0.9,
      };

      try {
        const imagenComprimida = await imageCompression(imagen, opciones);

        const extension = imagen.name.split('.').pop();
        const nuevoNombre = `${imagen.name.split('.')[0]}.${extension}`;

        //Crear un nuevo objeto File con nombre y extension correcta
    const archivoFinal = new File (
      [imagenComprimida],
      nuevoNombre,
      {
        type: imagen.type,
        lastModified: Date.now()
      }
    );
        return archivoFinal;
    } catch (error) {
        console.error('Error al comprimir imagen:', error);
        return imagen; // Si falla, usa la imagen original
    }
    };


        const handleImageUpload = async (file, campoDestino, setUrl, setPreview) => {
        const archivoComprimido = await comprimirImagen(file);

        const formData = new FormData();
        formData.append('file', archivoComprimido);

        const username = user?.codigoUsuario || 'ADMIN';

        try {
            const response = await fetch(
                `${server}/CrmEncuestums/upload?usuario=${username}&idEncuesta=${editEncuesta.idEncuesta}&campoDestino=${campoDestino}`,
                {
                    method: 'POST',
                    body: formData
                }
            );

            if (response.ok) {
                const data = await response.json();
                setUrl(data.url);
                setPreview(URL.createObjectURL(archivoComprimido));
            } else {
                alert('Error al subir la imagen');
            }
        } catch (error) {
            console.error(error);
            alert('Error al subir la imagen');
        }
    };




    const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editEncuesta? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editEncuesta ? `${server}/CrmEncuestums/${editEncuesta.idEncuesta}` : `${server}/CrmEncuestums`;
    

            let encuestaActiva = activa;
            
            //Valida si se quiere activar una encuesta y ya hay otra activa en el area mientras se edita
              if (editEncuesta && activa && areaSeleccionada?.id) {
                try{
                  const checkResponse = await fetch(`${server}/CrmEncuestums/estado/activa/${areaSeleccionada.id}`);
                  const activeEncuesta = await checkResponse.json();

                  if (
                    activeEncuesta && activeEncuesta.idEncuesta && activeEncuesta.idEncuesta !== editEncuesta.idEncuesta
                  ) {
                    encuestaActiva = false;
                    setActiva(false);

                    await Swal.fire({
                      icon: 'warning',
                      title: 'Encuesta activa existente',
                      text:' Ya hay otra encuesta activa en esta área. Esta encuesta se guardará como inactiva.',
                      confirmButtonText: 'Entendido'
                    });
                  }
                  } catch (error) {
                    await Swal.fire({
                      icon: 'error',
                      title: 'Error al verificar encuesta activa',
                      text: error.toString() || 'No se pudo validar la encuesta activa existente.',
                    });
                    return;
                }
              }
           

            const encuesta = { 
                idEncuesta:editEncuesta ? editEncuesta.idEncuesta:0,
                titulo,
                descripcion,
                activa: encuestaActiva,
                idAreaEncuesta: areaSeleccionada?.id || null,
                IngresadoPor: !editEncuesta ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editEncuesta ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada,
                UrlImagenInicioEncuesta: urlImagenInicio,
                UrlImagenFinalEncuesta: urlImagenFinal,
          
                
            };

            Object.keys(encuesta).forEach(key => encuesta[key] === undefined && delete encuesta[key]);
            console.log('Datos enviados a la API:', encuesta);
            console.log(endpoint)
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(encuesta),
                });
    
                if (response.ok) {

                  const text = await response.text();
                  const data =  text ? JSON.parse(text) : {};
                   
                  
                  const encuestaId = 
                  editEncuesta ? editEncuesta.idEncuesta : data.idEncuesta || data.id;
                  console.log(encuestaId);
                  if (data && data.advertencia !== null && data.advertencia !== undefined) {
                    // console.log("Se detectó advertencia. Mostrando Swal...");
                    await Swal.fire({
                      icon: 'warning',
                      title: 'Atencion',
                      text: data.advertencia.toString() || 'La encuesta fue guardada con una advertencia.',
                      confirmButtonText: 'Entendido'
                    });
                  }


                  // Guardar el link generado si viene en la respuesta
                  if (data.linkGenerico) {
                    setLinkGenerado(data.linkGenerico); }


                    // Limpiar el formulario y manejar la respuesta si es necesario
                    setTitulo('');
                    setDescripcion('');
                    setActiva(false);
                    setAreaSeleccionada(null);
                    setModificacion(1);
                    setIngresadoPor('');
                    setUrlImagenInicio('');
                    setUrlImagenFinal('');
                    setImagenInicioPreview(null);
                    setImagenFinalPreview(null);
                    setEliminarInicio(null);
                    setEliminarFinal(null);

                    if (inputInicioRef.current) inputInicioRef.current.value = null;
                    if (inputFinalRef.current) inputFinalRef.current.value = null;

                    await Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewEncuesta();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar la Encuesta',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

        useEffect(() => {
  if (activa && areaSeleccionada?.id) {
    const url = `${encuesta}laboratorio/encuesta-satisfaccion/${areaSeleccionada.id}`;
    setLinkGenerado(url);
  } else {
    setLinkGenerado('');
  }
}, [activa, areaSeleccionada]);

        const handleCancelarEdicion = () => {
          setTitulo('');
          setDescripcion('');
          setActiva(false);
          setAreaSeleccionada(null);
          setModificacion(1);
          setIngresadoPor('');
          if(cancelarEdicion) cancelarEdicion();
        }

  const renderContenido = () => {
    switch (seccionSeleccionada) {
      case 'Encuesta':
        return (
          <Box component="form" onSubmit={handleSubmit}>
            <Typography variant="h6">Detalles de la Encuesta</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <TextField
                    fullWidth
                    label="Titulo de la encuesta"
                    value={titulo}
                    onChange={(e) => setTitulo(e.target.value)}
                    sx={{ mt: 2 }}
                    disabled={editEncuesta?.tieneRespuestas}
                    />
                </Grid>
                <Grid item xs={6}>
                    <TextField
                    fullWidth
                    label="Descripción de la encuesta"
                    value={descripcion}
                    onChange={(e) => setDescripcion(e.target.value)}
                    sx={{ mt: 2 }}
                    disabled={editEncuesta?.tieneRespuestas}
                    />
                </Grid>
                
                <Grid item xs={6}>
                  <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}></label>
                  <Checkbox
                    
                    checked={activa}
                    onChange={(e) => setActiva(e.target.checked)}
                  />
                  <Typography sx={{ color: 'gray' }}>Encuesta Activa</Typography>
                </Grid>

                <Grid item xs={6}>
                <Autocomplete
                    options={areas}
                    getOptionLabel={(option) => option?.areaEncuesta || ''}
                    value={areaSeleccionada}
                    onChange={(event, newValue) => setAreaSeleccionada(newValue)}
                    disabled={editEncuesta?.tieneRespuestas}
                    renderInput={(params) => 
                      <TextField
                        {...params} 
                        label="Area" 
                        fullWidth
                />}     
                />
                </Grid>
               
              
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1">Imagen de Inicio de encuesta</Typography>
                    <Button variant="outlined" component="label" fullWidth disabled={editEncuesta?.tieneRespuestas}>
                        Subir Imagen
                        
                        <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0], 'UrlImagenInicioEncuesta', setUrlImagenInicio, setImagenInicioPreview)}/>
                    </Button>
                    {imagenInicioPreview || urlImagenInicio ? (
                        <Box mt={2}>
                            <img src={imagenInicioPreview || urlImagenInicio} alt="Preview" style={{ maxHeight: 150 }} />
                        </Box>
                    ) : null}
                </Grid>


               <Grid item xs={6}>
                  <Typography variant="subtitle1">Imagen Final de encuesta</Typography>
             
                    <Button variant="outlined" component="label" fullWidth disabled={editEncuesta?.tieneRespuestas}>
                        Subir Imagen
                        
                        <input type="file" hidden onChange={(e) => handleImageUpload(e.target.files[0], 'UrlImagenFinalEncuesta', setUrlImagenFinal, setImagenFinalPreview)}/>
                    </Button>
                    {imagenFinalPreview || urlImagenFinal ? (
                        <Box mt={2}>
                            <img src={imagenFinalPreview || urlImagenFinal} alt="Preview" style={{ maxHeight: 150 }} />
                        </Box>
                    ) : null}
                </Grid>

              <Grid item xs={6}>
                {/* MOSTRAR LINK GENERADO */}
                  {linkGenerado && (
                    <div style={{ marginTop: 20 }}>
                      <label>Link generado:</label>
                      <input
                        type="text"
                        value={linkGenerado}
                        readOnly
                        style={{ width: '100%' }}
                      />
                      <button
                        type="button"
                        onClick={() => navigator.clipboard.writeText(linkGenerado)}
                      >
                        Copiar link
                      </button>
                    </div>
                  )}
                </Grid>
                
                <Grid item xs={12} sx={{mt: 3}}>
                  <Button type="submit" variant="contained" color="success" disabled={!tienePermiso('Crear Encuesta')}>
                    {editEncuesta ? 'Actualizar' : 'Guardar'}
                  </Button>
                  
                    {editEncuesta && (
                      <Button type="button" variant="contained" color="secondary" onClick={handleCancelarEdicion}>
                        Cancelar
                        </Button>
                    )}
                  
                  
                  </Grid>
                </Grid>
          </Box>
          
          
          
        );
        
      case 'Preguntas':
        return (
          <Box>
            <Typography variant="h6"></Typography>
              <GestionPreguntaEncuesta idEncuesta={editEncuesta?.idEncuesta} preguntas={preguntas} onUpdate={handleNewEncuesta} modoLectura={editEncuesta?.tieneRespuestas}/>
          </Box>
        );
        return null;
    }
  };

  return (
    <div>
    <Box sx={{ display: 'flex', height: '100%', mt: 4, pb: 7  }}>
      {/* Sidenav */}
      <Paper elevation={3} sx={{ width: 220, mr: 3, p: 2 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>Secciones</Typography>
        <List>
          {['Encuesta', 'Preguntas'].map((seccion) => (
            <ListItem key={seccion} disablePadding>
              <ListItemButton
                selected={seccionSeleccionada === seccion}
                onClick={() => setSeccionSeleccionada(seccion)}
              >
                <ListItemText primary={seccion} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>

      {/* Contenido derecho */}
      <Paper elevation={3} sx={{ flex: 1, p: 3 }}>
        {renderContenido()}
      </Paper>
      
    </Box>
    
        </div>

    
  );
}
export default AddEncuesta;